import { render, staticRenderFns } from "./ShouldKnow.vue?vue&type=template&id=50822ab8&scoped=true"
import script from "./ShouldKnow.vue?vue&type=script&lang=js"
export * from "./ShouldKnow.vue?vue&type=script&lang=js"
import style0 from "./ShouldKnow.vue?vue&type=style&index=0&id=50822ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50822ab8",
  null
  
)

export default component.exports